<section
  scId="SC1048"
  *ngIf="aemContent && tileIDInFocusLineDetails"
  tmoGoToRepdashTop
  [goToTop]="true"
  id="product-selector-loading"
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <div *ngIf="isNewProductSelectorTemplateEnabled">
    <tmo-change-entry
      [aemContent]="aemContent"
      (browseEntryChange)="navigateHome()"
    ></tmo-change-entry>
  </div>
  <tmo-page-titles
    *ngIf="!isNewProductSelectorTemplateEnabled"
    [isFractionalPage]="true"
    [pageTitle]="componentName"
  ></tmo-page-titles>
  <!-- Line Carousel Section-->
  <ng-container *ngIf="!isNewProductSelectorTemplateEnabled && hasPermissionToAddALIne">
    <tmo-line-carousel
      id="line-carousel"
      [aemContent]="aemContent"
      [focusedTileIdDetails]="tileIDInFocusLineDetails"
      [currentVoiceLineCount]="currentVoiceLineCount"
      [nonLineItemCount]="nonLineItemCount"
    ></tmo-line-carousel>
    <tmo-add-remove-line
      *ngIf="!isUpgrade"
      id="add-remove-line"
      [aemContent]="aemContent"
      [isLineCompleted]="!tileIDInFocusLineDetails?.isLineSetupCompleted"
      (errorMessage)="displayErrorMessage($event)"
      [focusedTileIdDetails]="tileIDInFocusLineDetails"
      [removeInCompleteLine]="removeInCompleteLine"
      [allLineDetails]="allLineDetails"
    ></tmo-add-remove-line>
    <div class="row m-t-md">
      <div class="col-12">
        <hr class="divider" />
      </div>
    </div>
  </ng-container>
  <!-- End Line Carousel Section-->
  <router-outlet (activate)="onActivate()"></router-outlet>
  <div class="m-t-xl" *ngIf="!isNewProductSelectorTemplateEnabled && productExists">
    <tmo-accessory-section
      *ngIf="!isUpgrade"
      [configurableContent]="aemContent"
      [focusedTileIdDetails]="tileIDInFocusLineDetails"
      [byodSimData]="byodSimData"
      [productName]="productName"
      [productSelectorLanding]="productSelectorLanding"
      [productExists]="productExists"
    >
    </tmo-accessory-section>
    <hr class="divider" />
  </div>
  <!-- CTAs -->
  <div class="row" *ngIf="!isNewProductSelectorTemplateEnabled">
    <div class="col-12 buttons-container button-spacing-legal">
      <div class="button-box">
        <ng-container *ngIf="hasPermissionToAddALIne">
          <button
            id="save-add-a-line-btn"
            *ngIf="!isUpgrade && !isByos"
            tabindex="{{ !tileIDInFocusLineDetails?.isLineSetupCompleted ? '-1' : '0' }}"
            [class.disabled]="!tileIDInFocusLineDetails?.isLineSetupCompleted || isTestDrivePlan"
            class="btn btn-secondary"
            (click)="saveAndAddLine()"
          >
            {{
              maxLinesReached && !isTestDrivePlan
                ? aemContent?.saveAndAddDevice
                : aemContent?.saveAndAddLine
            }}
          </button>
          <!--QC613477-->
          <button
            id="save-add-a-line-btn-byos"
            *ngIf="isByos && !maxLinesReached"
            tabindex="{{ !tileIDInFocusLineDetails?.isLineSetupCompleted ? '-1' : '0' }}"
            [class.disabled]="!tileIDInFocusLineDetails?.isLineSetupCompleted || disableAddALine"
            class="btn btn-secondary"
            (click)="saveAndAddLine()"
          >
            {{ maxLinesReached ? aemContent?.saveAndAddDevice : aemContent?.saveAndAddLine }}
          </button>
        </ng-container>
        <button
          id="buy-more-devices-btn"
          *ngIf="isUpgrade"
          tabindex="0"
          class="btn btn-secondary"
          [routerLink]="['/browse-phones']"
        >
          Buy more devices
        </button>
      </div>
      <div class="button-box">
        <!--TODO: temporary change, logic needs to be refactored properly-->
        <button
          id="go-to-cart"
          tabindex="{{ !tileIDInFocusLineDetails?.isLineSetupCompleted ? '-1' : '0' }}"
          [disabled]="!tileIDInFocusLineDetails?.isLineSetupCompleted"
          class="btn btn-primary"
          (click)="goToCart()"
        >
          {{ aemContent?.goToCart }}
        </button>
      </div>
    </div>
  </div>
  <!-- End CTAs -->
</section>
<div class="row" *ngIf="!isNewProductSelectorTemplateEnabled && legalText && legalText?.length > 0">
  <div class="col-12">
    <tmo-container-holder
      *ngIf="legalText"
      (pageLoadedEvent)="hideSpinner($event)"
      [id]="aemId"
      [isDynamicContent]="legalText"
    >
    </tmo-container-holder>
  </div>
</div>
<tmo-spinner [setDelay]="aemContent && !showSpinner && tileIDInFocusLineDetails"></tmo-spinner>
